import ArchivioFascicoliTemplate from './ArchivioFascicoliTemplate/ArchivioFascicoliTemplate'
import AreaClientiTemplate from './AreaClientiTemplate/AreaClientiTemplate'
import ArticoloTemplate from './ArticoloTemplate/ArticoloTemplate'
import CategoriaProdottoTemplate from './CategoriaProdottoTemplate/CategoriaProdottoTemplate'
import ChiSiamoTemplate from './ChiSiamoTemplate/ChiSiamoTemplate'
import ContattaciTemplate from './ContattaciTemplate/ContattaciTemplate'
import ContattaciThankYouTemplate from './ContattaciThankYouTemplate/ContattaciThankYouTemplate'
import Custom404Template from './Custom404Template/Custom404Template'
import FaqDetailTemplate from './FaqDetailTemplate/FaqDetailTemplate'
import FaqListingTemplate from './FaqListingTemplate/FaqListingTemplate'
import HomeTemplate from './HomeTemplate/HomeTemplate'
import LayoutEmpty from './LayoutEmpty/LayoutEmpty'
import MagazineTemplate from './MagazineTemplate/MagazineTemplate'
import PortaleValorizzazioniTemplate from './PortaleValorizzazioniTemplate/PortaleValorizzazioniTemplate'
import PreventivatoreThankYouTemplate from './PreventivatoreThankYouTemplate/PreventivatoreThankYouTemplate'
import ProdottoTemplate from './ProdottoTemplate/ProdottoTemplate'
import ReclamiTemplate from './ReclamiTemplate/ReclamiTemplate'
import SearchResultsTemplate from './SearchResultsTemplate/SearchResultsTemplate'
import SinistroTemplate from './SinistroTemplate/SinistroTemplate'
import CatchAllTemplate from './CatchAllTemplate/CatchAllTemplate'

export {
  ArchivioFascicoliTemplate,
  AreaClientiTemplate,
  ArticoloTemplate,
  CatchAllTemplate,
  CategoriaProdottoTemplate,
  ChiSiamoTemplate,
  ContattaciTemplate,
  ContattaciThankYouTemplate,
  Custom404Template,
  FaqDetailTemplate,
  FaqListingTemplate,
  HomeTemplate,
  LayoutEmpty,
  MagazineTemplate,
  PortaleValorizzazioniTemplate,
  PreventivatoreThankYouTemplate,
  ProdottoTemplate,
  ReclamiTemplate,
  SearchResultsTemplate,
  SinistroTemplate,
}
